// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"38e6c8fe","753":"a8f2e8a0"}[chunkId] + ".css";
};